"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.onChangeDateRangeField = exports.mapDateTimeRangeFieldProperties = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireDefault(require("react"));

var _reactLoadable = _interopRequireDefault(require("react-loadable"));

var _Loader = _interopRequireDefault(require("../../Loader"));

var _DateHelper = require("../../Utilities/DateHelper");

var _Validations = require("../../Validations");

var _FieldMapper = _interopRequireWildcard3(require("./FieldMapper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var LoadableDateRange = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../DateTimeRange"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});

var getValidations = function getValidations(field) {
  var validations = [];
  validations.push(_Validations.rangeRequiredValidation);
  validations.push(_Validations.dateRangeValidDateValidation);
  validations.push(_Validations.dateRangeBoundryValidation);

  if (field.properties.allowRecurring) {
    validations.push(_Validations.recurrenceValidation);
  }

  return validations;
};

var mapInputProperties = function mapInputProperties(field, model, isModifying) {
  return _objectSpread(_objectSpread({}, model), {}, {
    component: LoadableDateRange,
    validations: getValidations(field),
    doNotValidate: true,
    fromProps: {
      label: "From",
      placeholder: field.properties.placeholder
    },
    toProps: {
      label: "To",
      placeholder: field.properties.placeholder
    },
    allowRecurring: !isModifying && field.properties.allowRecurring,
    onChange: onChangeDateRangeField,
    pickerType: field.properties.editor === "DateTimeRange" ? "dateTime" : "date",
    format: field.properties.editor === "DateTimeRange" ? "M/d/yyyy h:mm aa" : "M/d/yyyy",
    keyboard: true,
    fullWidth: true
  });
};

var mapDateTimeRangeFieldProperties = function mapDateTimeRangeFieldProperties(_ref) {
  var field = _ref.field,
      htmlId = _ref.htmlId,
      display = _ref.display,
      value = _ref.value,
      isModifying = _ref.isModifying,
      onValidation = _ref.onValidation;
  var displayValue = display; // We received a date value from the form builder, but no value
  // has been entered into the date picker yet. Need to populate the
  // display value

  if (displayValue == null || displayValue.from == null && displayValue.to == null) {
    if (value) {
      var start = value["startDate"];
      var end = value["endDate"];
      var startDate = (0, _DateHelper.convertDateTimeValueToUtc)(new Date(start));
      var endDate = (0, _DateHelper.convertDateTimeValueToUtc)(new Date(end));
      displayValue = {
        from: startDate,
        to: endDate
      };
    } else {
      displayValue = {};
      displayValue = {
        from: null,
        to: null
      };
    }
  }

  var model = (0, _FieldMapper.default)(field, htmlId, displayValue, undefined, onValidation);
  return mapInputProperties(field, model, isModifying);
};

exports.mapDateTimeRangeFieldProperties = mapDateTimeRangeFieldProperties;

var onChangeDateRangeField = function onChangeDateRangeField(params) {
  // const event = params[0];
  var value = params[1];
  var date = {
    display: {
      from: "",
      to: ""
    },
    value: {
      startDate: null,
      endDate: null
    }
  };

  if (value) {
    date.display = {
      from: value.from,
      to: value.to
    };
    date.value.startDate = (0, _DateHelper.convertDateTimeValueToUtc)(value.from);
    date.value.endDate = (0, _DateHelper.convertDateTimeValueToUtc)(value.to);
    date.value.recurrence = value.recurrence;
  }

  return date;
};

exports.onChangeDateRangeField = onChangeDateRangeField;
var _default = mapDateTimeRangeFieldProperties;
exports.default = _default;